import { Grid, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import classes from "./index.module.scss";
import atoms from "../../atoms";

export default function SimilarSchoolModal({ isFocused, schooList }: any) {
  const { Table } = atoms;
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);

  const education_setting = [
    {
      name: "#",
      cell: (row: any, index: number) =>
        ((page - 1) * limit + index + 1).toString().padStart(2, "0"),
      width: "50px",
      tblName: "",
    },
    {
      name: "Education Name",
      cell: (item: any, ind: number) => (
        <Tooltip title={item?.school_name} className={classes.text_wrap}>
          <span>{item?.school_name}</span>
        </Tooltip>
      ),
      selector: (item: any, ind: number) => item?.school_name,
      draggable: false,
      sortable: true,
      width: "50%",
      tblName: "school_name",
    },
    {
      name: "Email",
      cell: (item: any, ind: number) => (
        <Tooltip title={item?.email} className={classes.text_wrap}>
          <span>{item?.email}</span>
        </Tooltip>
      ),
      selector: (item: any, ind: number) => item?.email,
      sortable: true,
      width: "50%",
      tblName: "email",
    },
  ];

  return (
    <>
      {isFocused && schooList.length > 0 && (
        <Grid
          sx={{
            position: "fixed",
            zIndex: 9,
            left: "50%",
            maxWidth: "40%",
            minWidth: "40%",
            top: "50%",
            transform: "translate(-81%, -50%)",
            backgroundColor: "#fff",
          }}
        >
          <Typography
            sx={{
              color: "#212121",
              fontWeight: "600",
              p: 2,
              background: "rgba(106, 35, 130, 0.1019607843)",
            }}
          >
            Similar School Found
          </Typography>
          <Table
            columns={education_setting}
            className={"userLisingTable"}
            data={schooList}
            paginationTotalRows={schooList.totalPages}
            setLimitPerPage={(e: any) => setLimit(e)}
            limit={limit}
            pagination={false}
            setCurrentPage={(e: any) => setPage(e)}
          />
        </Grid>
      )}
    </>
  );
}
